__turbopack_context__.v({
  "className": "philosopher_ce02923f-module__2szGoq__className",
});
